/**
 * Sysadmin Governance — parent layout (Wave 3 §10.2 #5 / spec §3.4).
 */

import { createFileRoute, Link, Outlet, useLocation } from '@tanstack/react-router';
import { ShieldAlert, Award, Tags, GitBranch, EyeOff } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export const Route = createFileRoute('/sysadmin/governance')({
  component: GovernanceLayout,
});

const SUB_TABS = [
  { key: 'guardrails',     label: 'Guardrails',         icon: ShieldAlert, to: '/sysadmin/governance/guardrails',     status: 'v1' },
  { key: 'compliance',     label: 'Compliance',         icon: Award,       to: '/sysadmin/governance/compliance',     status: 'v1' },
  { key: 'classification', label: 'Classification',     icon: Tags,        to: '/sysadmin/governance/classification', status: 'v1' },
  { key: 'approvals',      label: 'Approval Policies',  icon: GitBranch,   to: '/sysadmin/governance/approvals',      status: 'v2' },
  { key: 'pii',            label: 'PII',                icon: EyeOff,      to: '/sysadmin/governance/pii',            status: 'v2' },
] as const;

function GovernanceLayout() {
  const location = useLocation();

  return (
    <div className="flex flex-col h-full">
      <div className="border-b sticky top-0 bg-background z-10">
        <nav className="flex items-center gap-0.5 overflow-x-auto px-6">
          {SUB_TABS.map((t) => {
            const Icon = t.icon;
            const active = location.pathname === t.to ||
              location.pathname.startsWith(t.to + '/');
            return (
              <Link
                key={t.key}
                to={t.to}
                className={cn(
                  'flex items-center gap-2 px-3 py-2 text-sm font-medium border-b-2 transition-colors whitespace-nowrap',
                  active
                    ? 'border-primary text-foreground'
                    : 'border-transparent text-muted-foreground hover:text-foreground',
                )}
              >
                <Icon className="h-4 w-4" />
                {t.label}
                {t.status !== 'v1' && (
                  <Badge variant="secondary" className="ml-1 text-[10px]">
                    {t.status}
                  </Badge>
                )}
              </Link>
            );
          })}
        </nav>
      </div>

      <div className="flex-1 overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}
